import {
  FETCH_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_REQUEST,
  FETCH_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_SUCCESS,
  FETCH_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_FAILURE,
} from '../../../actions/actionTypes'

import fetchStatusesByCustomerIdReducerCreator from '../higherOrderReducers/reducerCreators/byCustomerId'

export default fetchStatusesByCustomerIdReducerCreator(
  FETCH_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_REQUEST,
  FETCH_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_SUCCESS,
  FETCH_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_FAILURE,
)
